import { render, staticRenderFns } from "./RestoreFileAction.vue?vue&type=template&id=23a21ca7"
import script from "./RestoreFileAction.vue?vue&type=script&lang=js"
export * from "./RestoreFileAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports